import type {
  CompanyGeneralSettingsDTO,
  CompanyMemberDTO,
  CompanyPackagesDTO,
  CreateMemberDTO,
} from '@conversed/shared/src/central/dto/company';
import type {
  PlatformFeaturesMetadata,
  PlatformFeatureType,
} from '@conversed/shared/src/central/types/platform-features.type';
import { ENDPOINTS } from '../constants/apiEndpoints';
import { axiosInterceptAccessTokenExpiry } from './axios/axiosIntercepted';
import type { TGeneralResponse } from './dto/common.dto';

export const getCompanyMembersApi = (): TGeneralResponse<CompanyMemberDTO[]> =>
  axiosInterceptAccessTokenExpiry().get(
    `${ENDPOINTS.COMPANY}/selected/members`,
  );

export const getAllMembersApi = (
  emailFilter: string,
): TGeneralResponse<string[]> =>
  axiosInterceptAccessTokenExpiry().get(`${ENDPOINTS.COMPANY}/members`, {
    params: { emailFilter },
  });

export const getCompanyGeneralSettingsApi =
  (): TGeneralResponse<CompanyGeneralSettingsDTO> =>
    axiosInterceptAccessTokenExpiry().get(
      `${ENDPOINTS.COMPANY}/selected/settings/general`,
    );

export const updateCompanyGeneralSettingsApi = (
  generalSettings: CompanyGeneralSettingsDTO,
): TGeneralResponse<CompanyGeneralSettingsDTO> =>
  axiosInterceptAccessTokenExpiry().put(
    `${ENDPOINTS.COMPANY}/selected/settings/general`,
    generalSettings,
  );
export const addCompanyMemberApi = (
  memberData: CreateMemberDTO,
): TGeneralResponse<CompanyMemberDTO> =>
  axiosInterceptAccessTokenExpiry().patch(
    `${ENDPOINTS.COMPANY}/selected/members`,
    memberData,
  );

export const activateCompanyApi = (): TGeneralResponse =>
  axiosInterceptAccessTokenExpiry().post(
    `${ENDPOINTS.COMPANY}/selected/activate`,
  );

export const deactivateCompanyApi = (): TGeneralResponse =>
  axiosInterceptAccessTokenExpiry().post(
    `${ENDPOINTS.COMPANY}/selected/deactivate`,
  );

export const removeCompanyMemberApi = (
  memberId: string,
): TGeneralResponse<CompanyMemberDTO> =>
  axiosInterceptAccessTokenExpiry().delete(
    `${ENDPOINTS.COMPANY}/selected/members/${memberId}`,
  );

export const updateCompanyPackagesApi = (
  packages: CompanyPackagesDTO,
): TGeneralResponse<CompanyPackagesDTO> =>
  axiosInterceptAccessTokenExpiry().put(
    `${ENDPOINTS.COMPANY}/selected/settings/packages`,
    packages,
  );

export const updateCompanyPlatformFeaturesApi = async (
  platformFeatures: PlatformFeatureType[],
) =>
  axiosInterceptAccessTokenExpiry().put(
    `${ENDPOINTS.COMPANY}/selected/settings/platform-features`,
    platformFeatures,
  );

export const updateCompanyPlatformFeaturesMetadataApi = async (
  metadata: PlatformFeaturesMetadata,
) =>
  axiosInterceptAccessTokenExpiry().put(
    `${ENDPOINTS.COMPANY}/selected/settings/platform-features-metadata`,
    metadata,
  );

export const shareMemberToStudiosApi = (
  companyIds: string[],
  memberData: CreateMemberDTO,
): TGeneralResponse<CompanyMemberDTO[]> =>
  axiosInterceptAccessTokenExpiry().post(`${ENDPOINTS.COMPANY}/members/share`, {
    companyIds,
    memberData,
  });

export const removeMemberFromStudiosApi = (
  memberId: string,
  companyIds: string[],
): TGeneralResponse<void> =>
  axiosInterceptAccessTokenExpiry().delete(
    `${ENDPOINTS.COMPANY}/members/${memberId}/studios`,
    { data: { companyIds } },
  );
